import i18next from 'i18next'
import {DoughnutChartData} from '@/components'
import {ECOMClients, ECOMSummaryResponse, SummaryByStatusItem} from '@/stores/reports'
import {OnlinePaymentStatus, POSPaymentStateStatus} from '@/constants'
import {getCardSchemeIconForChart} from '@/services/card-scheme'
import {renderLabel} from '@/utils/chart'
import {colors} from '@/constants/theme/colors'
import {DOUGHNUT_CHART_CARD_SCHEME_COLORS} from '@/constants/theme/doughnut-chart-colors'

export const posStateSummaryList: SummaryByStatusItem[] = [
    {
        status: POSPaymentStateStatus.successful,
        count: 0,
        amount: 0
    },
    {
        status: POSPaymentStateStatus.failed,
        count: 0,
        amount: 0
    }
]

export const getDefaultSummaryByStatusItem = (
    status: OnlinePaymentStatus
): SummaryByStatusItem => ({
    status,
    count: 0,
    amount: 0,
    percent: 0
})

export const getDoughnutClientsChartData = (data: ECOMClients): DoughnutChartData => ({
    labels: [
        i18next.t('ClientsDoughnutChart.newCustomers'),
        i18next.t('ClientsDoughnutChart.returningCustomers')
    ],
    total: data.new + data.returning,
    datasets: [
        {
            data: [data.new, data.returning],
            backgroundColor: [colors.yellow1, colors.primary800]
        }
    ]
})

export const getDoughnutChartAmountData = (
    data: ECOMSummaryResponse,
    parseLabel = (label: any) => label,
    chartColors: string[] = DOUGHNUT_CHART_CARD_SCHEME_COLORS
): DoughnutChartData => ({
    labels: [...(data?.map((item) => renderLabel(item.value, parseLabel)) ?? [])],
    total: data?.reduce((acc, obj) => acc + obj.amount, 0),
    icons: getDoughnutIconsByLabel(data),
    datasets: [
        {
            data: [...(data?.map((item) => item.amount) ?? [])],
            backgroundColor: chartColors
        }
    ]
})

export const getDoughnutChartCountData = (
    data: ECOMSummaryResponse,
    parseLabel = (label: any) => label,
    chartColors: string[] = DOUGHNUT_CHART_CARD_SCHEME_COLORS
): DoughnutChartData => ({
    labels: [...(data?.map((item) => renderLabel(item.value, parseLabel)) ?? [])],
    total: data?.reduce((acc, obj) => acc + obj.count, 0),
    icons: getDoughnutIconsByLabel(data),
    datasets: [
        {
            data: [...(data?.map((item) => item.count) ?? [])],
            backgroundColor: chartColors
        }
    ]
})

export const getDoughnutIconsByLabel = (data: ECOMSummaryResponse) => {
    if (!data) {
        return []
    }

    return data?.map((item) => {
        const cardSchemeIcon = getCardSchemeIconForChart(item.value)
        if (cardSchemeIcon) return cardSchemeIcon

        switch (item.value) {
            case 'card':
                return 'card_payments'
            case 'JPMORGAN CHASE BANK, N.A.':
                return 'jpmorgan_chase_logo'
            case "Sainsbury's Bank plc":
                return 'sainsburry_logo'
            case 'BARCLAYS':
                return 'barclays_logo'
            case 'EUROPAY INTERNATIONAL, S.A.':
                return 'europay_logo'
            case 'googlepay':
                return 'google_pay'
            case 'ecospend':
            case 'openbanking':
                return 'openbanking_logo'
            case 'applepay':
                return 'apple_pay_logo'
            case 'paybybankapp':
                return 'pay_by_bank_logo'
            default:
                return 'card_payments'
        }
    })
}
